import React from "react";
import { useSelector } from "react-redux";
import SFFatalError from "../fatalError";

const PageErrorBoundary = ({ children }) => {
  const pageError = useSelector((state) => state.session.pageError);

  return pageError ? <SFFatalError /> : children;
};

export default PageErrorBoundary;
